import React from 'react';
import { Spin } from 'antd';

export const ImageWithLoader = ({ children, loading, height }) => {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height,
        borderRadius: 10,
        overflow: 'hidden',
      }}
    >
      {loading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.6)',
            zIndex: 2,
          }}
        >
          <Spin />
        </div>
      )}
      {children}
    </div>
  );
};
